import { render, staticRenderFns } from "./3_m_giftCard.vue?vue&type=template&id=e6ed9f2c&scoped=true&"
import script from "./3_m_giftCard.vue?vue&type=script&lang=js&"
export * from "./3_m_giftCard.vue?vue&type=script&lang=js&"
import style0 from "./3_m_giftCard.vue?vue&type=style&index=0&id=e6ed9f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ed9f2c",
  null
  
)

export default component.exports